import Service from "./service.abstract";

export default class AlertesCriteresService extends Service {
  constructor(url: string) {
    super();
    this.url = url;
    this.displayDefaultError = false;
    this.errorTopic = "service.error.alertescriteres";
  }
}
